import {
  DELETE_OFFICE_IMAGE,
  DELETE_PROFILE_IMAGE,
  SET_OFFICE_IMAGE,
  SET_PROFILE_IMAGE,
  SET_PROFILE_IMAGE_TYPE,
} from "../constants/profile-image";
import { Action, PictureData } from "../models/profile-image";

const initialState: PictureData = {
  profileImage: null,
  profileImageId: "",
  officeImages: [],
  type: "",
};

const profileImageReducer = (state: PictureData = initialState, action: Action): PictureData => {
  switch (action.type) {
    case SET_PROFILE_IMAGE: {
      return {
        ...state,
        profileImage: action.payload.image,
        profileImageId: action.payload.id,
      };
    }
    case DELETE_PROFILE_IMAGE:
      return {
        ...state,
        profileImage: null,
        profileImageId: "",
      };

    case SET_OFFICE_IMAGE: {
      // Check if the image already exists in officeImages
      const imageExists = state.officeImages.some((officeImage) => officeImage.id === action.payload.image.id);
      if (imageExists) {
        return state;
      }
      return {
        ...state,
        officeImages: [...state.officeImages, action.payload.image],
      };
    }
    case DELETE_OFFICE_IMAGE: {
      return {
        ...state,
        officeImages: [],
      };
    }

    case SET_PROFILE_IMAGE_TYPE:
      return {
        ...state,
        type: action.payload.type,
      };

    default:
      return state;
  }
};

export default profileImageReducer;
